import React, { useState } from "react";
import Modal from "../../components/common/Modal";


const AbsentSmsSettings = () => {
    const initialForm = {
        id: null,
        session: "",
        absentStatus: "",
        smsMode: "",
        role: "",
        smsDescription:
            "Attendance alert: Dear Parent, your ward $studentname attendance status: Present, Time: $time. Thank you $orgname",
        smsTime: "14:00",
    };

    const [showModal, setShowModal] = useState(false);
    const [search, setSearch] = useState("");
    const [formData, setFormData] = useState(initialForm);

    const [smsSettings, setSmsSettings] = useState([
        {
            id: 1,
            session: "STUDENTS SESSION",
            absentStatus: "Absent",
            smsMode: "SMS",
            role: "Parent",
            smsDescription:
                "Attendance alert: Dear Parent, your ward $studentname attendance status: Absent, Time: $time. Thank you $orgname",
            smsTime: "14:00",
        },
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.id) {
            setSmsSettings((prev) =>
                prev.map((item) =>
                    item.id === formData.id ? formData : item
                )
            );
        } else {
            setSmsSettings((prev) => [
                ...prev,
                {
                    ...formData,
                    id: Date.now(),
                },
            ]);
        }

        setShowModal(false);
        setFormData(initialForm);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure want to delete?")) {
            setSmsSettings((prev) =>
                prev.filter((item) => item.id !== id)
            );
        }
    };

    const filteredData = smsSettings.filter((item) =>
        Object.values(item)
            .join(" ")
            .toLowerCase()
            .includes(search.toLowerCase())
    );
    return (
        <>
            <div className="card shadow-sm">
                {/* Header */}
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 text-uppercase">
                        List Of Absent
                    </h4>

                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            setFormData(initialForm);
                            setShowModal(true);
                        }}
                    >
                        Add Absent SMS Setting
                    </button>
                </div>

                <div className="card-body">
                    {/* Top Controls */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex gap-2">
                            <span>
                                <select
                                    className="form-select"
                                    style={{ width: "70px" }}
                                >
                                    <option>10</option>
                                    <option>25</option>
                                    <option>50</option>
                                    <option>100</option>
                                </select>
                            </span>
                            <button className="btn btn-secondary">
                                <i className="bi bi-cloud-download-fill"></i>
                            </button>


                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <label className="mb-0">Search:</label>

                            <input
                                type="text"
                                className="form-control"
                                style={{ width: "180px" }}
                                value={search}
                                onChange={(e) =>
                                    setSearch(e.target.value)
                                }
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive border">
                        <table className="table align-middle">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Absent Status</th>
                                    <th>Send SMS Time</th>
                                    <th>SMS Mode</th>
                                    <th>Role</th>
                                    <th>SMS Description</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((row, index) => (
                                        <tr key={row.id}>
                                            <td>{index + 1}</td>
                                            <td>{row.absentStatus}</td>
                                            <td>{row.smsTime}</td>
                                            <td>{row.smsMode}</td>
                                            <td>{row.role}</td>
                                            <td style={{maxWidth:300}}>{row.smsDescription}</td>

                                            <td className="d-flex">
                                                <button
                                                    className="btn btn-success btn-sm me-2"
                                                    onClick={() => {
                                                        setFormData(row);
                                                        setShowModal(true);
                                                    }}
                                                >
                                                    <i className="bi bi-pencil"></i>
                                                </button>

                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(row.id)}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No data available in table
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            Showing 0 to 0 of 0 entries
                        </div>

                        <div>
                            <button className="btn btn-light border me-1">
                                <i className="bi bi-chevron-double-left"></i>
                            </button>

                            <button className="btn btn-light border">
                                <i className="bi bi-chevron-double-right"></i>
                            </button>
                        </div>
                    </div>

                    {/* Export */}
                    <button className="btn btn-info text-white mt-3">
                        Export to Excel
                    </button>
                </div>
            </div>


            <Modal
                show={showModal}
                onClose={() => setShowModal(false)}
                title={
                    formData.id
                        ? "Edit Absent SMS Setting"
                        : "Add Absent SMS Setting"
                }
                size="lg"
            >
                <form onSubmit={handleSubmit}>
                    <div className="container-fluid">

                        {/* Session */}
                        <div className="mb-3">
                            <label className="form-label">
                                * Sessions (Student Timings)
                            </label>

                            <select
                                className="form-select"
                                name="session"
                                value={formData.session}
                                onChange={handleChange}
                            >
                                <option value="">
                                    -Select Session-
                                </option>

                                <option value="STUDENTS SESSION">
                                    STUDENTS SESSION
                                </option>

                                <option value="STAFF SESSION">
                                    STAFF SESSION
                                </option>
                            </select>
                        </div>

                        {/* Absent Status */}
                        <div className="mb-3">
                            <label className="form-label">
                                Absent Status
                            </label>

                            <select
                                className="form-select"
                                name="absentStatus"
                                value={formData.absentStatus}
                                onChange={handleChange}
                            >
                                <option value="">
                                    ---SELECT---
                                </option>

                                <option value="Present">
                                    Present
                                </option>

                                <option value="Absent">
                                    Absent
                                </option>

                                <option value="Late">
                                    Late
                                </option>
                            </select>
                        </div>

                        {/* SMS Mode */}
                        <div className="mb-3">
                            <label className="form-label">
                                SMS Mode
                            </label>

                            <select
                                className="form-select"
                                name="smsMode"
                                value={formData.smsMode}
                                onChange={handleChange}
                            >
                                <option value="">
                                    ---SELECT---
                                </option>

                                <option value="SMS">
                                    SMS
                                </option>

                                <option value="WhatsApp">
                                    WhatsApp
                                </option>

                                <option value="Both">
                                    SMS + WhatsApp
                                </option>
                            </select>
                        </div>

                        {/* Role */}
                        <div className="mb-3">
                            <label className="form-label">
                                Role
                            </label>

                            <select
                                className="form-select"
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                            >
                                <option value="">
                                    ---SELECT---
                                </option>

                                <option value="Parent">
                                    Parent
                                </option>

                                <option value="Student">
                                    Student
                                </option>

                                <option value="Staff">
                                    Staff
                                </option>
                            </select>
                        </div>

                        {/* SMS Description */}
                        <div className="mb-3">
                            <label className="form-label">
                                SMS Description
                            </label>

                            <textarea
                                rows="4"
                                className="form-control"
                                name="smsDescription"
                                value={formData.smsDescription}
                                onChange={handleChange}
                            />
                        </div>

                        {/* SMS Time */}
                        <div className="mb-4">
                            <label className="form-label">
                                Absent Send SMS Time
                            </label>

                            <input
                                type="time"
                                className="form-control"
                                style={{ maxWidth: "180px" }}
                                name="smsTime"
                                value={formData.smsTime}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Buttons */}
                        <div className="d-flex gap-2">
                            <button
                                type="submit"
                                className="btn btn-info text-white px-4"
                            >
                                {formData.id ? "Update" : "Submit"}
                            </button>

                            <button
                                type="button"
                                className="btn btn-light border px-4"
                                onClick={() => setShowModal(false)}
                            >
                                Cancel
                            </button>
                        </div>

                    </div>
                </form>
            </Modal>
        </>
    );
};

export default AbsentSmsSettings;